<template>
    <div>
        <div :class="{'px-4': headerInset}">
        <v-row class="mb-0" v-if="!readonly">
            <v-col>
                <eod-user-selector placeholder="Bestaande gebruiker zoeken..." dense return-object :roleNames="roles" v-model="searchItem" @change="addItem" :item-disabled="itemDisabled" class="white"></eod-user-selector>
            </v-col>
            <v-col sm="auto" class="d-flex align-items-center">
                <eod-btn id="btn_create_user" mdi-icon="mdi-plus" label="Nieuwe gebruiker" small color="primary" class="mr-2" @click="showAddItem">
                </eod-btn>
                <template v-if="importShow">
                <input type="file" class="d-none" ref="importFile" @change="uploadFileImport">
                <v-btn rounded depressed text small :loading="importLoading" class="mr-2" @click="importItems">
                    <v-icon left>mdi-import</v-icon> Importeren
                </v-btn>
                <v-btn v-if="exportShow && hasItems" rounded depressed text small :loading="exportLoading" class="mr-2"
                    @click="exportItems">
                    <v-icon left>mdi-export</v-icon> Exporteren
                </v-btn>
            </template>
            </v-col>
        </v-row>
    </div>
        <v-card :outlined="outlined" :flat="flat">
                <div v-if="hasItems">
                    <div v-for="(group, groupname) in itemsGrouped" :key="groupname">
                        <v-divider></v-divider>
                        <eod-card v-if="groupname != ''" :subtitle="groupname == 'COMPANY'?'Gebruikers gekoppeld aan het bedrijf hebben toegang tot alle projecten onder het bedrijf.':'Gebruikers gekoppeld aan het project.'" outlined :title="$t(groupname)" :icon="groupname == 'COMPANY'?'mdi-office-building-outline':'mdi-folder-open-outline'" color="grey lighten-5">
                            <v-list dense>
                                <eod-contacts-list-item v-for="item in group" :key="item.id" :value="item" :readonly="readonly || item.readonly" :show-role="showRole"
                                    @delete="deleteItem(item)" @edit="editItem(item)">
                                <template v-slot:actions="{user}">
                                    <slot name="actions" v-bind:user="user"></slot>
                                </template>
                                </eod-contacts-list-item>
                            </v-list>
                        </eod-card>
                        <v-list v-else dense color="transparent">
                                <eod-contacts-list-item v-for="item in group" :key="item.id" :value="item" :readonly="readonly || item.readonly" :show-role="showRole"
                                    @delete="deleteItem(item)" @edit="editItem(item)">
                                <template v-slot:actions="{user}">
                                    <slot name="actions" v-bind:user="user"></slot>
                                </template>
                                </eod-contacts-list-item>
                            </v-list>
                    </div>
                    
                </div>
                <v-alert dense color="grey" text v-else>
                    <span v-if="!readonly">Er zijn nog geen gebruikers gekoppeld.</span>
                    <span v-else>Er zijn geen gebruikers gekoppeld.</span>
                </v-alert>
            <v-dialog v-if="userDialog" v-model="userDialog" persistent scrollable max-width="800px">
                <eod-add-contact v-model="editUser" :roles="roles" :show-role="showRole" @onCancel="userDialog = false"
                    @onSaved="itemSaved"></eod-add-contact>
            </v-dialog>
            <eod-errors-dialog v-model="showErrors" :errors="importErrors" title="Fout bij importeren!"></eod-errors-dialog>
        </v-card>
    </div>
</template>

<script>
import { User } from './../models';
import eodErrorsDialog from './eod-errors-dialog.vue';
import eodAddContact from './eod-add-contact.vue';
import eodUserSelector from './eod-user-selector.vue';
import eodContactsListItem from './eod-contacts-list-item.vue';

export default {
    name: 'Contacts',
    props: {
        value: Array,
        roles: Array,
        importAction: Function,
        defaultRole: Object,
        importShow: {
            type: Boolean,
            default: true
        },
        showRole: {
            type: Boolean,
            default: false
        },
        exportShow: {
            type: Boolean,
            default: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        flat: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        headerInset: Boolean,
    },
    components: {
        eodAddContact,
        eodErrorsDialog,
        eodUserSelector,
        eodContactsListItem
    },
    data() {
        return {
            exportLoading: false,
            searchItem: null,
            timeout: null,
            userDialog: false,
            importLoading: false,
            editUser: new User(),
            showErrors: false,
            importErrors: [],
            items: [],
            cancelRequest: null,
            config: {
                import: {
                    endpoint: 'Users',
                    objectName: 'User'
                }
            }
        }
    },
    mounted() {
        if (this.value && this.value.length > 0) {
            this.loadUsers();
        }
    },
    computed: {
        hasItems() {
            for (const groupname in this.itemsGrouped) {
                if (this.itemsGrouped.hasOwnProperty(groupname)) {
                    const items = this.itemsGrouped[groupname];
                    for (let i = 0; i < items.length; i++) {
                        return true;
                    }
                }
            }

            return false;
        },
        itemsGrouped() {
            let grouped = {};

            if (this.items) {
                for (let i = 0; i < this.items.length; i++) {
                    const element = this.items[i];

                    if (!element.getRole()) {
                        continue;
                    }

                    if (!this.roles.includes(element.getRole().name)) {
                        continue;
                    }
                    
                    const itemType = element.type || '';
                    if (!grouped[itemType]) {
                        grouped[itemType] = [];
                    }

                    grouped[itemType].push(element);
                }
            }

            return grouped;
        }
    },
    methods: {
        loadUsers() {

            if (this.cancelRequest) {
                this.cancelRequest.cancel();
            }

            this.items = [];
            let users = this.value;

            let ids = [];
            for (let i = 0; i < users.length; i++) {
                const user = users[i];
                ids.push(user.id);
            }

            this.cancelRequest = this.$eod.getCancelRequest();

            let extra = {
                cancelToken: this.cancelRequest.token
            };


            // Filter users
            this.$eod.get('resolveUsers', ['id', 'profilePicture{key}', 'firstName', 'lastName', 'username', 'email', 'assignedRealmRoles{id name}', 'notificationSettings', 'attributes{phone_number extra_email extra_phone locale jobtitle}'], { // 'attributes{phone_number extra_email extra_phone}'
                whereIn: {
                    column: 'id',
                    array: ids
                }
            }, extra)
                .then(result => {
                    if(result?.data?.data){
                        const items = [];
                        users.forEach(user => {
                            const resolvedUser = result.data.data.resolveUsers.edges.find(u => u.id === user.id);
                            if(resolvedUser){
                                const data = {
                                    ...user,
                                    ...resolvedUser
                                };
                                items.push(new User(data));
                            }
                        });

                        items.sort((a, b) => {
                            return b.type?.localeCompare(a.type) || a.getFullName().localeCompare(b.getFullName());
                        });

                        this.items = items;                        
                    } else {
                        this.items = [];
                    }

                    this.$forceUpdate();
                    
                });
        },
        getTitle(item) {
            return item.getFullName();
        },
        itemDisabled(item) {
            if (this.items) {
                for (let j = 0; j < this.items.length; j++) {
                    if (item.id == this.items[j].id) {
                        return true;
                    }
                }
            }
            return false;
        },
        deleteItem(item) {
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].id == item.id) {
                    this.items.splice(i, 1);
                    this.$emit('input', this.items);
                    return;
                }
            }
        },
        editItem(item) {

            // Get user
            this.$eod.getById('user', item.id, ['id', 'firstName', 'lastName', 'username', 'email', 'notificationSettings', 'projects{id}', 'companies{id}', 'depot{id name streetAddress postalCode locality country category}', 'assignedRealmRoles{id name}', 'attributes{phone_number, jobtitle nickname birthdate gender locality locale iban bic postal_code street_address region country notes extra_email extra_phone}'])
                .then(result => {
                    this.editUser = new User(result.data.data.user);
                    this.userDialog = true;
                });
        },

        async itemSaved(item) {
            this.userDialog = false;
            this.addItem(item);
        },
        showAddItem() {
            const user = new User();
            if (this.defaultRole) {
                user.assignedRealmRoles = [this.defaultRole];
            }
            this.editUser = user;
            this.userDialog = true;
        },
        addItem(item) {
            if (!this.items) {
                this.items = [];
            }

            if(this.items.find(i => i.id === item.id)){
                this.$forceUpdate();
                return;
            }

            this.items.push(item);
            this.$emit('input', this.items);

            this.$emit('add', item);

            this.$nextTick(() => {
                this.searchResults = [];
                this.search = '';
                this.searchItem = null;

                this.$forceUpdate();
            });
        },
        uploadFileImport() {
            this.importLoading = true;

            if (this.importAction) {
                this.importAction(this.$refs.importFile.files[0]).then(result => {
                    this.$toaster.notify({
                        type: 'success',
                        title: this.$t('Succes'),
                        body: this.$t('Gebruikers zijn succesvol geïmporteerd!')
                    });
                    this.importLoading = false;
                }).catch(e => {
                    this.importErrors = e.response.data.errors;
                    this.showErrors = true;
                    this.importLoading = false;
                });
            } else {
                this.$eod.importUsers(this.$refs.importFile.files[0])
                    .then(result => {
                        if (result.data.success) {
                            this.$toaster.notify({
                                type: 'success',
                                title: this.$t('Succes'),
                                body: this.$t('Gebruikers zijn succesvol geïmporteerd!')
                            });
                        }
                        this.importLoading = false;
                    }).catch(error => {
                        this.importErrors = e.response.data.errors;
                        this.showErrors = true;
                        this.importLoading = false;
                    });
            }
        },
        importItems() {
            this.$refs.importFile.click();
        },
        exportItems() {
            this.exportLoading = true;
            let ids = [];
            for (const groupname in this.items) {
                if (this.items.hasOwnProperty(groupname)) {
                    const items = this.items[groupname];
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        ids.push(item.id);
                    }
                }
            }

            this.$eod.exportUsers({
                whereIn: {
                    column: 'id',
                    array: ids
                }
            })
                .then(result => {
                    if (result.data.success) {
                        window.location.href = result.data.path;
                    }
                    this.exportLoading = false;
                }).catch(err => {
                    this.exportLoading = false;
                });
        },
    },
    watch: {
        value(val) {
            this.loadUsers();
        },
    },
}
</script>